import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, Mail } from 'lucide-react';
import { toast } from 'sonner';

const ExtractEmailsTool = () => {
  const [input, setInput] = useState('');
  const [unique, setUnique] = useState(true);

  const extractEmails = () => {
    if (!input) return [];
    const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
    const matches = input.match(emailRegex) || [];
    return unique ? [...new Set(matches)] : matches;
  };

  const emails = extractEmails();
  const output = emails.join('\n');

  const copyEmails = () => {
    navigator.clipboard.writeText(output);
    toast.success(`${emails.length} email(s) copied!`);
  };

  const copyAsCsv = () => {
    navigator.clipboard.writeText(emails.join(', '));
    toast.success('Emails copied as CSV!');
  };

  return (
    <div className="space-y-6" data-testid="extract-emails-tool">
      <div className="flex gap-4">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={unique}
            onChange={(e) => setUnique(e.target.checked)}
            className="rounded"
          />
          <span className="text-sm">Remove Duplicates</span>
        </label>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">
            Input Text
          </label>
          <Textarea
            placeholder="Paste text containing email addresses..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="min-h-[250px] font-mono text-sm bg-muted/50"
          />
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block flex items-center gap-2">
            <Mail className="w-4 h-4 text-primary" />
            Extracted Emails ({emails.length})
          </label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[250px] font-mono text-sm bg-muted/50"
            placeholder="Extracted emails will appear here..."
          />
        </div>
      </div>

      <div className="flex gap-2 flex-wrap">
        <Button onClick={copyEmails} disabled={emails.length === 0}>
          <Copy className="w-4 h-4 mr-2" /> Copy Emails
        </Button>
        <Button onClick={copyAsCsv} variant="outline" disabled={emails.length === 0}>
          Copy as CSV
        </Button>
        <Button onClick={() => setInput('')} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default ExtractEmailsTool;
